import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowIconBtn from "../../../../components/RightArrowIconButton/ArrowIconBtn";
import DownLoadTemplateDialog from "./DownLoadTemplateDialog";
import UploadPolicyDialog from "./UploadPolicyDialog";

function SetupPolicyDialog({
  open,
  onClose,
  policyData,
  refetch,
  version,
  isCreate,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [openUploadPolicyDialog, setOpenUploadPolicyDialog] = useState(false);
  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle fontWeight="bold">
          {` Set Up ${policyData.policyDisplayName}`}
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body1" gutterBottom>
            Generate a new version of the document.
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              mt: 2,
            }}
          >
            {policyData?.policyFileName && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  borderRadius: "8px",
                  border: "1px solid #C5C9CF",
                  background: "#F7F7FC",
                  padding: "16px",
                }}
              >
                <Box>
                  <Typography color="#031B89" fontWeight="bold" fontSize="18px">
                    Use Regodit Template
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: "400", fontSize: "14px" }}
                  >
                    Preview and download template provided by Regodit.
                  </Typography>
                </Box>
                <ArrowIconBtn onClick={() => setIsOpen(true)} />
              </Box>
            )}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderRadius: "8px",
                border: "1px solid #C5C9CF",
                background: "#F7F7FC",
                padding: "16px",
              }}
            >
              <Box>
                <Typography color="#031B89" fontWeight="bold" fontSize="18px">
                  Upload File
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: "400", fontSize: "14px" }}
                >
                  Add non-editable document. (Docx)
                </Typography>
              </Box>
              <ArrowIconBtn onClick={() => setOpenUploadPolicyDialog(true)} />
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      <DownLoadTemplateDialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        policyData={policyData}
      />
      <UploadPolicyDialog
        open={openUploadPolicyDialog}
        onClose={() => setOpenUploadPolicyDialog(false)}
        policyData={policyData}
        close={onClose}
        refetch={refetch}
        version={version}
        isCreate={isCreate}
      />
    </>
  );
}

export default SetupPolicyDialog;
